import { BaggageType, LegType } from '@shared/interfaces/baggage';

export function getFieldName(type: BaggageType, leg: LegType, paxIndex: number) {
    return `${type}_${leg}_${paxIndex}`;
}
